import { supabase } from "@/services/supabase/client";
import { Database } from "@/services/supabase/types";

type DbProfiles = Database["public"]["Tables"]["profiles"];
export type ProfileRow = DbProfiles["Row"];
export type ProfileInsert = DbProfiles["Insert"];
export type ProfileUpdate = DbProfiles["Update"];

async function fetchProfile(userId: string): Promise<ProfileRow | null> {
  const { data, error } = await supabase.from("profiles").select("*").eq("id", userId).maybeSingle();

  if (error) {
    throw error;
  }

  return data;
}

async function createProfile(profile: ProfileInsert): Promise<ProfileRow> {
  const { data, error } = await supabase.from("profiles").insert(profile).select().single();

  if (error) {
    throw error;
  }

  return data;
}

async function updateProfile(userId: string, profile: ProfileUpdate): Promise<ProfileRow> {
  const { data, error } = await supabase.from("profiles").update(profile).eq("id", userId).select().single();

  if (error) {
    throw error;
  }

  return data;
}

async function deleteProfile(userId: string): Promise<void> {
  const { error } = await supabase.from("profiles").delete().eq("id", userId);

  if (error) {
    throw error;
  }
}

export const profilesFetchers = {
  createProfile,
  deleteProfile,
  fetchProfile,
  updateProfile,
};
